import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';

export const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${mediaConfined} {
    flex-direction: row;
  }
`;
